import FluidGlass from '@/components/FluidGlass';
import { HomeHeader } from './home-header/home-header';
import { HomeAbout } from './home-about/home-about';
import HomeBussinesses from './home-businesses/home-businesses';
import HomePartners from './home-partners/home-partners';
import GradualBlur from '@/components/GradualBlur';
import DownloadTheApp from './download-the-app/download-the-app';
import HomeNova from './home-nova/home-nova';

export function Home() {
  return (
    <section className="relative overflow-hidden">

        <HomeHeader />
        <HomeAbout />
        {/* <HomeNova /> */}
        <HomePartners />
        {/* <HomeBussinesses /> */}
        {/* <DownloadTheApp /> */}



    </section>
  );
}